module.exports = __webpack_public_path__ + "img/logo-icon-app.bed92fbb.png";